import React, { useContext } from "react";
// import {
//   ProSidebar,
//   Menu,
//   MenuItem,
//   SidebarHeader,
//   SidebarFooter,
//   SidebarContent,
// } from "react-pro-sidebar";
// import "react-pro-sidebar/dist/css/styles.css";
import Chat_alt_svg from "../../../svg/svg-sidebar/Chart_alt_svg";
import Plus_svg from "../../../svg/svg-sidebar/Plus_svg";
import Chartfill_svg from "../../../svg/svg-sidebar/Chartfill_svg";
import OrderList_svg from "../../../svg/svg-sidebar/OrderList_svg";
import OrderReports from "../../../svg/svg-sidebar/OrderReports";
import { routeConstant } from "../../../../Route/utils/routeConstant";
import { NavLink, useLocation } from "react-router-dom";
import { StoreContext } from "../../../store";
import "./sidebar.css";
import Setting_svg from "../../../svg/svg-sidebar/Setting_svg";
import Search_svg from "../../../svg/svg-sidebar/Search_svg";
// import { LOCAL_STORAGE_KEY, basename } from "../../../../config";
// import { StoreContext as OldStoreContext } from "../../../../store/Provider";

function Sidebar() {
  const location = useLocation();
  // const context = useContext(StoreContext);
  // const oldContext = useContext(OldStoreContext);
  return (
    <div>pro side bar code</div>
    // <div className="_sideBarInner">
    //   <ProSidebar breakPoint="lg" collapsed={context.collapsed}>
    //     <SidebarHeader>
    //       {context.collapsed ? (
    //         <div className="_sidebarHeaderMini">
    //           <img
    //             className="_sidebarLogoMini"
    //             src={`/${basename}/Assets/Images/SidebarLogoMini.png`}
    //             alt="Sidebar Logo"
    //           />
    //         </div>
    //       ) : (
    //         <div className="_sidebarHeader">
    //           <img
    //             className="_sidebarLogo"
    //             src={`/${basename}/Assets/Images/SidebarLogo.png`}
    //             alt="Sidebar Logo"
    //           />
    //         </div>
    //       )}
    //     </SidebarHeader>
    //     <SidebarContent>
    //       <Menu iconShape="square">
    //         <MenuItem
    //           className={
    //             location.pathname.includes(routeConstant.DASHBOARD)
    //               ? context.collapsed
    //                 ? "_activeMenu"
    //                 : "_activeMenu _activeMenuFull"
    //               : ""
    //           }
    //           icon={
    //             <Chartfill_svg
    //               colorCode={
    //                 location.pathname.includes(routeConstant.DASHBOARD)
    //                   ? "#002E76"
    //                   : "#ccd2e2"
    //               }
    //             />
    //           }
    //         >
    //           {context.collapsed ? "" : "Dashboard"}
    //           <NavLink to={routeConstant.DASHBOARD} />
    //         </MenuItem>

    //         <MenuItem
    //           className={
    //             location.pathname.includes(routeConstant.ORDER_LIST)
    //               ? context.collapsed
    //                 ? "_activeMenu"
    //                 : "_activeMenu _activeMenuFull"
    //               : ""
    //           }
    //           icon={
    //             <OrderList_svg
    //               colorCode={
    //                 location.pathname.includes(routeConstant.ORDER_LIST)
    //                   ? "#002E76"
    //                   : "#ccd2e2"
    //               }
    //             />
    //           }
    //         >
    //           {context.collapsed ? "" : "Order List"}
    //           <NavLink to={routeConstant.ORDER_LIST} />
    //         </MenuItem>
    //         {!context.userAccess?.CreateOrder ? (
    //           ""
    //         ) : (
    //           <>
    //             <hr />
    //             <MenuItem
    //               className={
    //                 location.pathname.includes(routeConstant.CREATE_ORDER_MAIN)
    //                   ? "_activeMenuCreateOrder _createNewOrder"
    //                   : "_createNewOrder"
    //               }
    //             >
    //               <div
    //                 className={
    //                   !context.collapsed ? "_newOrder " : "_newOrder _invisible"
    //                 }
    //               >
    //                 <div className="_plus">
    //                   <Plus_svg colorCode={"#CCD2E3"} />
    //                 </div>
    //                 <div>
    //                   <button>Create New Order</button>
    //                 </div>
    //               </div>
    //               {context.collapsed ? (
    //                 <div className="_newOrder_Collapsed">
    //                   <div className="_newOrderSvgParent">
    //                     <Plus_svg
    //                       colorCode={
    //                         location.pathname.includes(
    //                           routeConstant.CREATE_ORDER_MAIN
    //                         )
    //                           ? "#002E76"
    //                           : "#CCD2E3"
    //                       }
    //                     />
    //                   </div>
    //                 </div>
    //               ) : null}

    //               <NavLink
    //                 to={routeConstant.CREATE_ORDER}
    //                 state={{ edit: false }}
    //               />
    //             </MenuItem>
    //           </>
    //         )}
    //         <hr />
    //         <MenuItem
    //           className={
    //             location.pathname === routeConstant.SYSTEM_LOG
    //               ? context.collapsed
    //                 ? "_activeMenu"
    //                 : "_activeMenu _activeMenuFull"
    //               : ""
    //           }
    //           icon={
    //             <Chat_alt_svg
    //               colorCode={
    //                 location.pathname === routeConstant.SYSTEM_LOG
    //                   ? "#002E76"
    //                   : "#ccd2e2"
    //               }
    //             />
    //           }
    //         >
    //           {context.collapsed ? "" : "System Log"}
    //           <NavLink to={routeConstant.SYSTEM_LOG} />
    //         </MenuItem>
    //         {oldContext.omsUserData?.DefaultRole.includes("Admin") ? (
    //           <MenuItem
    //             className={
    //               location.pathname === routeConstant.SETTINGS
    //                 ? context.collapsed
    //                   ? "_activeMenu"
    //                   : "_activeMenu _activeMenuFull"
    //                 : ""
    //             }
    //             icon={
    //               <Setting_svg
    //                 colorCode={
    //                   location.pathname === routeConstant.SETTINGS
    //                     ? "#002E76"
    //                     : "#ccd2e2"
    //                 }
    //               />
    //             }
    //           >
    //             {context.collapsed ? "" : "Admin Settings"}
    //             <NavLink to={routeConstant.SETTINGS} />
    //           </MenuItem>
    //         ) : (
    //           ""
    //         )}
    //       </Menu>
    //     </SidebarContent>
    //   </ProSidebar>
    //   <div
    //     className="_closeMenu"
    //     style={{ display: context.collapsed ? "inline-block" : "" }}
    //     onClick={() => context.setCollapsed((prev) => !prev)}
    //   >
    //     {context.collapsed ? (
    //       <img
    //         src={`/${basename}/Assets/Images/OpenMenu.png`}
    //         alt="Open Menu"
    //       />
    //     ) : (
    //       <img
    //         src={`/${basename}/Assets/Images/CloseMenu.png`}
    //         alt="Close Menu"
    //       />
    //     )}
    //   </div>
    // </div>
  );
}

export default Sidebar;
